import {
  LAZY_PRODUCTS_URL,
  LAZY_PRODUCTS_CLASS
} from './const';
import {
  stringToHTML,
  showMessage,
  logMessage,
  isVisible,
  debounce,
  getResponseByMode
} from './utils';
import {
  updateBasketFromList
} from './action';
import {
  lazy
} from '../base';
import {
  getMainProducts,
  getGoodsProducts
} from './sliders';


export function loadLazyProducts(cls = LAZY_PRODUCTS_CLASS) {
  const sliders = document.querySelectorAll(cls);
  let count = sliders.length;

  document.addEventListener('scroll', documentLoadAndScrollHandler);
  document.addEventListener('DOMContentLoaded', documentLoadAndScrollHandler);

  function documentLoadAndScrollHandler() {
    sliders.forEach(elem => {
      const isNewAndVisible = elem && !elem.classList.contains('loading') && !elem.classList.contains('loaded') && isVisible(elem);

      if (isNewAndVisible) {
        const productSliderAjax = new LazySlider({
          elem,
          cls
        });
        productSliderAjax.init();
        --count;
      }

      if (count === 0) {
        document.removeEventListener('scroll', documentLoadAndScrollHandler);
        document.removeEventListener('DOMContentLoaded', documentLoadAndScrollHandler);
      }

    });
  }
}

class LazySlider {
  constructor(options) {
    this.elem = null;
    this.cls = null;
    this._type = null;
    this._sfx = null;
    this._productId = null;
    this._callback = null || getGoodsProducts;

    Object.assign(this, options);

    this._loadResults = debounce(this._loadResults.bind(this));
  }

  init() {
    this.elem.classList.add('loading');

    this._checkData();
    this._loadResults();
  }

  _checkData() {
    const type = this.elem.dataset.type;
    const sfx = this.elem.dataset.sfx;
    const productId = this.elem.dataset.productid;
    const callback = this.elem.dataset.callback;
    if (type) {
      this._type = type;
    } else {
      throw new Error('Укажите тип подгружаемых товаров');
    }
    if (sfx) {
      this._sfx = sfx;
      this.elem.removeAttribute('data-sfx');
    }
    if (productId) {
      this._productId = productId;
      this.elem.removeAttribute('data-productId');
    }
    if (callback === 'getMainProducts') {
      this._callback = getMainProducts;
      this.elem.removeAttribute('data-callback');
    }
  }

  _loadResults() {
    const mock = 'mocks/popular.html';
    const path = window.location.origin + LAZY_PRODUCTS_URL[this._type];

    const real = this._productId ? path + this._productId : path;
    const url = getResponseByMode(mock, real);

    if (url === null || url === undefined || this._isLoaded()) {
      return;
    }

    this._showResults(url);
  }

  _showResults(url) {
    const whenProductsLoad = this._loadedResults();

    whenProductsLoad(url)
      .then(() => {
        const isSlider = this.elem.querySelector(`.products__splide`);
        if (isSlider) {
          const slider = this._callback(this.elem);
          slider.mount();
          lazy.update();
          updateBasketFromList(this.elem);
        }
      })
      .catch((error) => {
        logMessage(error);
        if (error.name === 'AbortError') {
          showMessage('Сервер долго не отвечает');
        } else {
          showMessage(error.message);
        }
      });
  }


  _loadedResults() {
    const that = this;
    let result;

    return function (url) {
      if (typeof result === 'undefined') {
        result = async function () {
          let controller = new AbortController();
          setTimeout(() => controller.abort(), 30000);

          const response = await fetch(url, {
            signal: controller.signal
          });
          const html = await response.text();
          if (html === '') {
            return false;
          }
          const doc = stringToHTML(html);
          const docWithClass = that._addClasses(doc);
          const container = that.elem.querySelector('.skeleton');
          container.replaceWith(docWithClass);
          that.elem.classList.remove('loading');
          that.elem.classList.add('loaded');

          return response;
        };
      }
      return result();
    };
  }

  _addClasses(data) {
    if (this._sfx) {
      const splideContainer = data.querySelector('.grid');
      splideContainer.classList.remove('grid');
      splideContainer.classList.add('grid' + this._sfx);
    }

    return data;
  }

  _isLoaded() {
    return this.elem.classList.contains('loaded');
  }
}
